import { useContext, useEffect } from 'react';
import NoSessionBackground from '../NoSessionBackground/NoSessionBackground';
import ErrorBoundary from '../../../../Components/ErrorBoundary/ErrorBoundary';
import { LoginStateContext } from '../../Contexts/LoginStateContext/LoginStateContext';
import {
  baseRouteValuesAreComplete,
  buildBasePath,
  currentRoutingVersion,
  useBaseRouteValue,
} from '../../../Routing/Utils/routerUtils';
import { Navigate } from 'react-router';
import { setPageTitle } from '../../../../Utils/analyticsUtils';

/**
 * Login komponenten omgiven av en bakgrund
 * Används nu bara om användaren specifikt gått till /login via någon länk
 */
const LoginPage = () => {
  const loginState = useContext(LoginStateContext);
  const baseRouteParams = useBaseRouteValue();
  const basePath = baseRouteValuesAreComplete(baseRouteParams)
    ? buildBasePath(baseRouteParams)
    : loginState.databases.at(0)
    ? buildBasePath({
        routingVersion: currentRoutingVersion,
        database: loginState.databases.at(0)?.name,
        username: loginState.sign,
      })
    : '';
  useEffect(() => {
    setPageTitle('Login');
  }, []);

  return (
    <ErrorBoundary name="Inloggning">
      <NoSessionBackground />
      {loginState.isLoggedIn && basePath && <Navigate to={basePath} replace />}
    </ErrorBoundary>
  );
};

export default LoginPage;
